var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBosnia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.992634C22.3139 0.993106 22.6743 1.12635 22.9401 1.36315C23.2059 1.59994 23.3555 1.92097 23.356 2.25585V19.962C23.3555 20.2968 23.2059 20.6179 22.9401 20.8547C22.6743 21.0914 22.3139 21.2247 21.938 21.2252H2.06201C1.6861 21.2247 1.32572 21.0914 1.05991 20.8547C0.7941 20.6179 0.644523 20.2968 0.643994 19.962V2.25585C0.644523 1.92097 0.7941 1.59994 1.05991 1.36315C1.32572 1.12635 1.6861 0.993106 2.06201 0.992634H21.938ZM21.938 0.418945H2.06201C1.5153 0.419417 0.991126 0.613107 0.604541 0.957488C0.217956 1.30187 0.000529505 1.76882 0 2.25585V19.962C0.000529505 20.449 0.217956 20.9159 0.604541 21.2603C0.991126 21.6047 1.5153 21.7984 2.06201 21.7989H21.938C22.4845 21.7979 23.0084 21.6041 23.3949 21.2598C23.7813 20.9155 23.9989 20.4488 24 19.962V2.25585C23.9995 1.76882 23.782 1.30187 23.3955 0.957488C23.0089 0.613107 22.4847 0.419417 21.938 0.418945Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643951 7.56878H1.87593L0.643951 8.36518V8.73221L1.04395 9.83862L0.643951 9.5785V10.2413H2.19996L2.71197 8.83732L3.22398 10.2413H4.87994L3.53995 11.1089L4.05196 12.5111L2.71197 11.6452L1.37195 12.5111L1.88394 11.1089L0.647955 10.309V19.962C0.648484 20.2969 0.798061 20.6179 1.06387 20.8547C1.32969 21.0915 1.69006 21.2247 2.06597 21.2252H13L12.546 20.9312H14.2L14.712 19.5273L15.224 20.9312H16.8799L16.4259 21.2252H18.3879L0.647955 5.42188L0.643951 7.56878ZM11.708 16.8548L12.22 18.2587H13.8759L12.5359 19.1264L13.048 20.5286L11.708 19.6609L10.368 20.5286L10.8799 19.1264L9.53995 18.2587H11.2L11.708 16.8548ZM8.70796 14.1823L9.21998 15.5863H10.8759L9.53594 16.4539L10.048 17.8561L8.70796 16.9902L7.36797 17.8561L7.87994 16.4539L6.53995 15.5863H8.19996L8.70796 14.1823ZM5.70797 11.5098L6.21998 12.9138H7.87593L6.53594 13.7814L7.04796 15.1836L5.70797 14.3177L4.36797 15.1836L4.87994 13.7814L3.53995 12.9138H5.19996L5.70797 11.5098Z",
    fill: "#2B2783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 0.992676H19.0279V21.2252H21.9379C22.3138 21.2247 22.6742 21.0915 22.94 20.8547C23.2058 20.6179 23.3554 20.2969 23.356 19.962V2.25589C23.3554 1.92101 23.2058 1.59998 22.94 1.36319C22.6742 1.12639 22.3138 0.993147 21.9379 0.992676Z",
    fill: "#2B2783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06197 0.992676C1.68605 0.993147 1.32568 1.12639 1.05987 1.36319C0.794057 1.59998 0.644481 1.92101 0.643951 2.25589V5.42188L18.3839 21.2252H19.0279V0.992676H2.06197Z",
    fill: "#FDC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643951 7.56885V8.36524L1.87596 7.56885H0.643951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643951 8.73193V9.57822L1.04796 9.83834L0.643951 8.73193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36795 12.5112L2.70797 11.6453L4.04796 12.5112L3.53597 11.109L4.87596 10.2414H3.21995L2.70797 8.8374L2.19595 10.2414H0.643951V10.3091L1.87996 11.109L1.36795 12.5112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88005 13.7814L4.36804 15.1835L5.70806 14.3177L7.04805 15.1835L6.53606 13.7814L7.87605 12.9137H6.22004L5.70806 11.5098L5.19604 12.9137H3.54004L4.88005 13.7814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88005 16.4537L7.36804 17.8559L8.70806 16.99L10.048 17.8559L9.53606 16.4537L10.876 15.5861H9.22004L8.70806 14.1821L8.19604 15.5861H6.54004L7.88005 16.4537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8801 19.1266L10.368 20.5288L11.7081 19.6611L13.048 20.5288L12.5361 19.1266L13.876 18.2589H12.22L11.7081 16.855L11.196 18.2589H9.54004L10.8801 19.1266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.22 20.9313L14.7081 19.5273L14.196 20.9313H12.54L12.994 21.2253H16.422L16.876 20.9313H15.22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosnia);
export default __webpack_public_path__ + "static/media/Bosnia.d955cb365699ba57cf29bc30be9a43e3.svg";
export { ForwardRef as ReactComponent };